<template>
  <v-container fluid class="pa-0 ma-0">
    <v-app id="inspire">
      <v-card class="elevation-0">
        <v-img class="white--text" max-height="590px" src="@/assets/aboutusbg.jpg">
          <v-container>
            <div class="mt-16 mx-lg-8 pt-lg-16">
              <v-row no-gutters>
                <v-col cols="12" sm="4" md="5">
                  <v-card class="ma-2 mt-16">
                    <div class="waviy">
                      <h1 class="clrbluetext font-weight-bold">
                        Sactin Interactive Panel
                      </h1>
                      <h2 class="linespht spans clrbluetext font-weight-bold">
                        Discover. Discuss. Develop.
                      </h2>
                    </div>
                  </v-card>
                </v-col>

                <v-col cols="12" sm="8" md="7">
                  <v-card
                    class="pa-2 ma-2 d-flex align-center justify-center htlargef mt-sm-16 mt-xl-8"
                    height="100%"
                  >
                    <v-img
                      src="@/assets/dgxg.png"
                      class="fill-height zoom-effect"
                      contain
                      max-width="100%"
                    />
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-img>
      </v-card>

      <!-- start sec part -->
      <!-- start sec part -->
      <v-card class="elevation-0 bgpanel">
        <v-container>
          <div>
            <v-row no-gutters>
              <!-- LEFT COLUMN -->
              <v-col cols="12">
                <!-- observer wrapper for mobile heading -->
                <div ref="leftHeadingMobile" class="observer">
                  <h1
                    class="rainbow-text text-center fontfamMon font-weight-bold linespht display-1 anim-item fade-up delay-100"
                    style="font-size: clamp(22px, 4vw, 32px) !important"
                  >
                    Interactive Panel...
                  </h1>
                </div>
              </v-col>
            </v-row>
          </div>
          <div class="mx-lg-8">
            <v-row no-gutters>
              <!-- LEFT COLUMN -->
              <v-col cols="12" sm="4" lg="3">
                <div ref="imageCard2" class="observer">
                  <v-card
                    class="px-2 mx-2 pb-2 mb-2 d-none d-sm-block align-center justify-center htlargef2 anim-item zoom-in delay-200"
                    height="100%"
                  >
                    <v-img
                      src="@/assets/companystory.jpg"
                      class="fill-height"
                      contain
                      max-width="100%"
                    />
                  </v-card>
                </div>
              </v-col>

              <!-- RIGHT COLUMN -->
              <v-col cols="12" sm="8" lg="9">
                <v-card class="ma-2">
                  <div ref="paragraph" class="observer">
                    <p
                      class="mt-6 mt-lg-14 text-justify linespht1 black--text body-1 anim-item fade-left delay-300"
                    >
                      Our motive is to work every day with the passion that drives us to
                      provide excellent support and to learn new things.We’re obsessively
                      passionate about our verticals, and our mission is to reach people,
                      small business and to achieve their goals.Our expertise is spread
                      wide across the fields of Software Development, web hosting, and
                      Server management
                    </p>
                  </div>
                </v-card>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <!-- observer wrapper for image card -->
              <v-col>
                <div ref="imageCard1" class="observer">
                  <v-card
                    class="px-12 mx-2 pb-2 mb-2 d-block d-sm-none align-center justify-center htlargef2 anim-item zoom-in delay-200"
                    height="100%"
                  >
                    <v-img
                      src="@/assets/companystory.jpg"
                      class="fill-height"
                      contain
                      max-width="100%"
                    />
                  </v-card>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-container>
      </v-card>
      <!-- end sec part -->
      <!-- start 3rd section -->
      <v-container fluid class="px-4">
        <v-card class="black--text elevation-0" dark>
          <v-container>
            <div>
              <v-row no-gutters>
                <v-col cols="12">
                  <v-card class="elevation-0">
                    <div class="waviy">
                      <h1
                        class="rainbow-text fontfamMon font-weight-bold linespht display-1"
                        style="font-size: clamp(22px, 4vw, 32px) !important"
                      >
                        Know about Sactin Panel
                      </h1>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-card>
      </v-container>

      <!-- start  4th section -->

      <v-container fluid class="pa-0 mb-0">
        <v-row no-gutters>
          <v-col cols="12">
            <!-- Background image wrapper -->
            <div class="bg-section d-flex align-center">
              <v-container>
                <v-row no-gutters justify="center">
                  <v-col cols="12" class="d-flex justify-center">
                    <v-card class="ma-2 pa-4" elevation="2" max-width="900">
                      <v-card-text class="text-center mx-auto">
                        <p class="linespht body-1 white--text shine-text">
                          We have a dedicated team of experienced software experts who can
                          transform customer needs into quality software products which
                          are unique in themselves and cut down the manual interventions
                          and costs. Our focus is on developing customized, client
                          friendly software that automates different areas of the business
                          process
                        </p>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </div>
          </v-col>
        </v-row>
      </v-container>
      <!-- end 4th section -->
      <!-- start sec part -->

      <v-card class="elevation-0 bgpanel">
        <v-container>
          <div class="mx-lg-8">
            <v-row no-gutters>
              <v-col cols="12" sm="6">
                <h1
                  class="linespht rainbow-text fontfamMon font-weight-bold d-block d-lg-none pl-3"
                >
                  Sactin
                </h1>
                <h2
                  class="linespht rainbow-text fontfamMon font-weight-bold d-block d-lg-none pl-3"
                >
                  Interactive Flat Panel
                </h2>
                <v-card
                  class="px-2 mx-2 pb-2 mb-2 d-flex align-center justify-center htlargef2"
                  height="100%"
                >
                  <v-img
                    src="@/assets/panellap2.png"
                    class="fill-height"
                    contain
                    max-width="100%"
                  />
                </v-card>
              </v-col>
              <v-col cols="12" sm="6">
                <v-card class="ma-2">
                  <h1
                    class="linespht rainbow-text fontfamMon font-weight-bold d-none d-lg-block"
                  >
                    Sactin
                  </h1>
                  <h2
                    class="linespht rainbow-text fontfamMon font-weight-bold d-none d-lg-block"
                  >
                    Interactive Flat Panel
                  </h2>

                  <p class="mt-6 text-justify linespht1" style="color: black">
                    "The Sactin series presents a comprehensive and interactive solution
                    equipped with a multi-touch screen, wireless collaboration features,
                    and robust software, tailored for both educational and corporate
                    environments. Available in display sizes of 65”, 75”, and 86”, it
                    elevates business meetings and educational sessions by fostering
                    enhanced collaboration and interaction."
                  </p>
                </v-card>
              </v-col>
            </v-row>
          </div>
        </v-container>
      </v-card>

      <!-- end sec part -->

      <!-- start -->
      <v-container fluid class="px-4 bgpanel">
        <v-card class="black--text elevation-0 bgpanel" dark>
          <v-container>
            <div>
              <v-row no-gutters>
                <v-col cols="12">
                  <v-card class="elevation-0">
                    <h1 class="linespht rainbow-text fontfamMon">Features</h1>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-card>
      </v-container>
      <!-- stop -->

      <!-- start 3rd section -->

      <v-container fluid class="pa-4 bgpanel">
        <v-card class="black--text elevation-0 bgpanel" dark>
          <v-container>
            <v-row class="mrtopmobile mx-xl-16 px-xl-15" justify="center">
              <!-- Start card loop -->
              <v-col
                v-for="(card, index) in cards"
                :key="index"
                cols="12"
                sm="4"
                lg="4"
                xl="4"
                class="d-flex justify-center"
              >
                <div class="a-box">
                  <div class="img-container d-flex justify-center"></div>
                  <div class="text-container d-flex flex-column justify-space-between">
                    <v-card class="d-flex flex-column" height="100%">
                      <v-img
                        :src="getImage(card.image)"
                        height="100%"
                        class="brradius"
                      ></v-img>

                      <v-card-title class="pa-3 text-center d-flex justify-center">{{
                        card.title
                      }}</v-card-title>

                      <p class="pa-3 body-1 text-center">
                        {{ card.description }}
                      </p>
                    </v-card>
                  </div>
                </div>
              </v-col>

              <!-- End card loop -->
            </v-row>
          </v-container>
        </v-card>
      </v-container>

      <!-- end 3rd section -->
      <!-- start 3rd section -->
      <v-container fluid class="px-4">
        <v-card class="black--text elevation-0" dark>
          <v-container>
            <div>
              <v-row no-gutters>
                <v-col cols="12">
                  <v-card class="elevation-0">
                    <div class="waviy">
                      <h1
                        class="rainbow-text fontfamMon font-weight-bold linespht display-1"
                        style="font-size: clamp(22px, 4vw, 32px) !important"
                      >
                        General Features
                      </h1>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-card>
      </v-container>

      <v-container class="pa-6">
        <v-row justify="center" align="center" no-gutters>
          <v-col
            v-for="(step, index) in steps"
            :key="index"
            cols="12"
            sm="3"
            class="d-flex flex-column align-center text-center"
          >
            <!-- Connector Line (before step) -->
            <div v-if="index > 0" class="timeline-line"></div>

            <!-- Step Circle -->
            <div class="timeline-circle">
              <v-icon color="white">{{ step.icon }}</v-icon>
            </div>

            <!-- Step Text -->
            <p class="mt-3 font-weight-medium">{{ step.text }}</p>
          </v-col>
        </v-row>
      </v-container>

      <!-- end 3rd section -->

      <!-- start  4th section -->

      <v-container fluid class="pa-0 mb-0">
        <div>
          <v-row no-gutters>
            <v-col cols="12">
              <v-img class="white--text htlargeproductscn" src="@/assets/newbgdd.jpg">
                <v-container>
                  <div>
                    <v-row no-gutters justify="center">
                      <v-col cols="12" class="d-flex justify-center">
                        <v-card class="ma-2" elevation="2">
                          <v-card-text class="text-center mx-auto">
                            <h1 class="linespht clrbluetext fd50 mb-6 shine-text2">
                              Products
                            </h1>
                            <h2 class="linespht ma-xl-6 d-none d-lg-block shine-text2">
                              Transform your conference room and classroom into a dynamic
                              learning and communication hub with Sactin Interactive
                              panels.
                            </h2>
                            <h3 class="linespht ma-xl-6 d-block d-lg-none shine-text2">
                              Transform your conference room and classroom into a dynamic
                              learning and communication hub with Sactin Interactive
                              panels.
                            </h3>
                          </v-card-text>
                          <!-- start slider -->

                          <v-container class="mt-8">
                            <v-row class="mrtopmobile mx-xl-16 px-xl-15" justify="center">
                              <v-col
                                v-for="(card, index) in productcards"
                                :key="index"
                                cols="12"
                                sm="6"
                                lg="3"
                                xl="3"
                                class="d-flex justify-center"
                              >
                                <div class="a-box">
                                  <div class="img-container d-flex justify-center"></div>
                                  <div
                                    class="text-container d-flex flex-column justify-space-between"
                                  >
                                    <v-card class="d-flex flex-column" height="100%">
                                      <v-img
                                        :src="getImage(card.image)"
                                        height="100%"
                                        class="brradius pa-6"
                                      ></v-img>

                                      <v-card-title
                                        class="py-3 px-0 subtitle-1 font-weight-bold mt-3 mb-5 text-center d-flex justify-center black--text"
                                        >{{ card.title }}</v-card-title
                                      >
                                    </v-card>
                                  </div>
                                </div>
                              </v-col>
                            </v-row>
                          </v-container>

                          <!-- end slider -->
                        </v-card>
                      </v-col>
                    </v-row>
                  </div>
                </v-container>
              </v-img>
            </v-col>
          </v-row>
        </div>
      </v-container>
      <!-- end 4th section -->

      <!-- start 5th section -->
      <v-container fluid class="pa-0 mb-2">
        <div>
          <v-row no-gutters>
            <v-col cols="12">
              <v-img
                class="white--text htlargecertificatescn"
                src="@/assets/Certificates BG.png"
              >
                <v-container>
                  <div>
                    <v-row no-gutters justify="center">
                      <v-col cols="12" class="d-flex justify-center">
                        <v-card class="ma-2" elevation="2">
                          <v-card-text class="text-center mx-auto">
                            <h2 class="linespht fd20ss mb-6 rainbow-text fontfamMon">
                              Sactin Interactive Panel Certification
                            </h2>
                          </v-card-text>
                          <!-- start slider -->

                          <v-container fluid class="mt-8">
                            <v-row no-gutters>
                              <v-col cols="12" sm="6">
                                <v-card
                                  class="px-2 mx-2 pb-2 mb-2 d-flex align-center justify-center htlargef2"
                                  height="100%"
                                >
                                  <!-- start imgs -->
                                  <v-container>
                                    <v-row class="mrtopmobile" justify="center">
                                      <v-col
                                        v-for="(card, index) in certificatecards"
                                        :key="index"
                                        cols="12"
                                        sm="5"
                                        lg="3"
                                        style="border: 1px solid black"
                                        class="d-flex justify-center ma-2 rounded-lg"
                                      >
                                        <div class="a-box">
                                          <div
                                            class="img-container d-flex justify-center"
                                          ></div>
                                          <div
                                            class="text-container d-flex flex-column justify-space-between"
                                          >
                                            <v-card
                                              class="d-flex flex-column"
                                              height="100%"
                                            >
                                              <v-img
                                                :src="getImage(card.image)"
                                                height="100%"
                                                class="brradius pa-6"
                                              ></v-img>
                                            </v-card>
                                          </div>
                                        </div>
                                      </v-col>
                                    </v-row>
                                  </v-container>

                                  <!-- end imgs -->
                                </v-card>
                              </v-col>

                              <v-col cols="12" sm="6" xl="5">
                                <v-card class="ma-2">
                                  <p
                                    class="mt-6 text-justify linespht"
                                    style="color: black"
                                  >
                                    "Sactin proudly offers industry-leading certification
                                    for interactive panels, designed to empower
                                    professionals with the skills needed to effectively
                                    install, operate, and maintain advanced interactive
                                    display systems. Our certification program covers key
                                    functionalities, troubleshooting techniques, and best
                                    practices to ensure users are proficient and confident
                                    in leveraging these technologies in various
                                    environments, including classrooms, boardrooms, and
                                    collaborative workspaces."
                                  </p>
                                </v-card>
                              </v-col>
                            </v-row>
                          </v-container>

                          <!-- end slider -->
                        </v-card>
                      </v-col>
                    </v-row>
                  </div>
                </v-container>
              </v-img>
            </v-col>
          </v-row>
        </div>
      </v-container>
      <!-- end 5th section -->

      <!-- start footer -->
      <WebsiteFooter />
      <!-- end footer -->
    </v-app>
  </v-container>
</template>

<script>
import WebsiteFooter from "../WebsitePages/WebsiteFooter.vue";
export default {
  components: {
    WebsiteFooter,
  },
  data() {
    return {
      observer: null,
      steps: [
        { icon: "mdi-hand-pointing-up", text: "Finger Touch" },
        { icon: "mdi-shield-check", text: "Scratch Resistant" },
        { icon: "mdi-crosshairs-gps", text: "Accurate Positioning" },
        { icon: "mdi-fire", text: "Fire Resistant" },
        { icon: "mdi-hammer-wrench", text: "Easy to Install" },
        { icon: "mdi-pencil-off", text: "No Specified Pen Required" },
        { icon: "mdi-shield-star", text: "5 Years Warranty" },
        { icon: "mdi-vector-combine", text: "Seamless Designs" },
        { icon: "mdi-broom", text: "Low Maintenance" },
        { icon: "mdi-weather-sunny-off", text: "Anti Glare" },
        { icon: "mdi-apps-box", text: "Rugged Ceramic Surface" },
        { icon: "mdi-numeric-9-circle", text: "9 Point Calibration" },
      ],
      cards: [
        {
          title: "4K-UHD Resolution",
          description:
            "For the Sactin brand, integrating 4K UHD resolution into its product lineup emphasizes its commitment to premium quality and state-of-the-art technology. Whether it s for monitors, TVs, or projectors, 4K UHD ensures users experience vibrant colors, exceptional brightness, and enhanced detail.",
          image: "panelpic11.png",
        },
        {
          title: "Interactive IR Touch Technology",
          description:
            "Interactive IR (Infrared) Touch Technology is a highly responsive and versatile touch solution that utilizes infrared sensors to detect touchpoints on a screen. This technology creates an invisible grid of light beams across the display surface, allowing for multi-touch functionality with high precision.",
          image: "panelpic22.png",
        },
        {
          title: "Whiteboard Software",
          description:
            "Whiteboard software panels are interactive digital tools designed to transform conventional displays into collaborative workspaces. They typically come equipped with touch functionality, annotation tools, and multimedia integration, making them ideal for classrooms, meetings, and creative sessions.",
          image: "panelpic33.png",
        },
      ],
      productcards: [
        {
          title: ' 65" Sactin Interactive Panel ',
          image: "productpanel11.png",
        },
        {
          title: ' 75" Sactin Interactive Panel ',
          image: "productpanel22.png",
        },
        {
          title: ' 85" Sactin Interactive Panel',
          image: "productpanel33.png",
        },
        {
          title: '98" Sactin Interactive Panel ',
          image: "productpanel44.png",
        },
      ],
      certificatecards: [
        {
          image: "Certification1.png",
        },
        {
          image: "Certification2.png",
        },
        {
          image: "Certification3.png",
        },
        {
          image: "Certification4.png",
        },
        {
          image: "Certification5.png",
        },
        {
          image: "Certification6.png",
        },
      ],
    };
  },
  methods: {
    getImage(imageName) {
      return require(`@/assets/${imageName}`);
    },
  },
  mounted() {
    const observer1 = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            observer1.unobserve(entry.target); // run only once
          }
        });
      },
      { threshold: 0.2 } // trigger when 20% visible
    );

    document.querySelectorAll(".process-circle").forEach((el) => {
      observer1.observe(el);
    });
    const options = {
      root: null,
      rootMargin: "0px 0px -10% 0px",
      threshold: 0.1,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const anim = entry.target.querySelector(".anim-item");
        if (!anim) return;

        if (entry.isIntersecting) {
          anim.classList.add("in-view"); // play animation
        } else {
          anim.classList.remove("in-view"); // reset when out of view
        }
      });
    }, options);

    [
      "leftHeadingMobile",
      "imageCard1",
      "imageCard2",
      "rightHeadingDesktop",
      "paragraph",
    ].forEach((ref) => {
      const el = this.$refs[ref];
      if (el) observer.observe(el);
    });
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
};
</script>

<style scoped>
::v-deep .theme--light.v-icon {
  color: white;
}
::v-deep .theme--light.v-sheet {
  background-color: transparent !important;
  border-color: transparent !important;
  color: white;
}
::v-deep .theme--dark.v-sheet {
  background-color: transparent;
  border-color: transparent;
  color: black;
}
::v-deep .v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: none !important;
}
.linespht {
  line-height: 1.5;
  letter-spacing: 2px;
}
.linespht1 {
  line-height: 1.5;
  letter-spacing: 1px;
}
@media screen and (min-width: 1100px) and (max-width: 1300px) {
  .htlargef {
    height: 90% !important;
  }
  .htlargeproductscn {
    height: 650px !important;
  }
  .htlargecertificatescn {
    height: 510px !important;
  }
}
@media screen and (min-width: 1301px) and (max-width: 1670px) {
  .htlargef {
    height: 90% !important;
  }
  .fd50SS {
    font-size: 50px !important;
  }
  .htlargeproductscn {
    height: 650px !important;
  }
  .htlargecertificatescn {
    height: 510px !important;
  }
}
@media screen and (min-width: 1671px) {
  .htlargef {
    height: 70% !important;
  }
  .fd50SS {
    font-size: 60px !important;
  }
  .htlargeproductscn {
    height: 710px !important;
  }
  .htlargecertificatescn {
    height: 710px !important;
  }
}
.htlargef2 {
  height: 100% !important;
}
.clrblues {
  background-color: #04357e !important;
  color: white;
}
@media screen and (min-width: 700px) {
  .fd20 {
    font-size: 20px;
  }
  .fd50 {
    font-size: 40px;
    line-height: 1.5;
    letter-spacing: 2px;
  }
  .fd50SS {
    font-size: 50px;
  }
  .htlargeproductscn {
    height: 1115px;
  }
  .fd20ss {
    font-size: 30px !important;
  }
}

/* start card */
.a-box {
  display: inline-block;
  width: 100% !important;

  text-align: center;
}

.img-container {
  height: 120px;
  width: 200px;
  overflow: hidden;
  border-radius: 0px 0px 20px 20px;
  display: inline-block;
}

.text-container {
  /* box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2); */
  padding: 10px;
  border-radius: 20px;
  /* background: #e5e5e5; */
  background: white;
  margin: -120px 0px 0px 0px;
  line-height: 19px;
  font-size: 14px;
  /* height: 200px; */
  /* height: 260px; */
}

.text-container h3 {
  margin: 20px 0px 10px 0px;
  /* color: #04bcff; */
  font-size: 18px;
}
.brradius {
  border-radius: 12px !important;
}

/* start slider */
.v-slide-group__prev,
.v-slide-group__next {
  color: purple; /* Customize the arrow color */
}
/* end slider */

/* start a1 */
.waviy {
  position: relative;
  -webkit-box-reflect: below -20px linear-gradient(transparent, rgba(0, 0, 0, 0.2));
  /* font-size: 40px; */
}
.waviy .spans {
  /* font-family: 'Alfa Slab One', cursive; */
  position: relative;
  display: inline-block;
  color: #fff;
  /* text-transform: uppercase; */
  animation: waviy 1s infinite;
  animation-delay: calc(0.1s * var(--i));
}

@keyframes waviy {
  0%,
  40%,
  100% {
    transform: translateY(0);
  }
  20% {
    transform: translateY(-20px);
  }
}

/* end a1 */

/* a2 */

.contentan {
  position: relative;
}

.contentan h2 {
  color: #fff;
  font-size: 3em;
  position: absolute;
  transform: translate(-50%, -50%);
}

.contentan h2:nth-child(1) {
  color: transparent;
  -webkit-text-stroke: 2px #04357e;
  /* -webkit-text-stroke: 2px  #2A65BF; */
}

.contentan h2:nth-child(2) {
  color: #04357e;
  animation: animate 4s ease-in-out infinite;
}

@keyframes animate {
  0%,
  100% {
    clip-path: polygon(
      0% 45%,
      16% 44%,
      33% 50%,
      54% 60%,
      70% 61%,
      84% 59%,
      100% 52%,
      100% 100%,
      0% 100%
    );
  }

  50% {
    clip-path: polygon(
      0% 60%,
      15% 65%,
      34% 66%,
      51% 62%,
      67% 50%,
      84% 45%,
      100% 46%,
      100% 100%,
      0% 100%
    );
  }
}
.letpx {
  left: 80px;
}
/* end a2 */
.clrbluetext {
  /* color: #04357e !important; */
  color: black;
}
/* ::v-deep .bgpanel.v-card.v-sheet.theme--light {
  background-color: #f8f8ff !important;
}
::v-deep .bgpanel {
  background-color: #f8f8ff !important;
} */

/* start a1 */
.waviy {
  position: relative;
  -webkit-box-reflect: below -20px linear-gradient(transparent, rgba(0, 0, 0, 0.2));
  /* font-size: 40px; */
}

.waviy .spans {
  /* font-family: 'Alfa Slab One', cursive; */
  position: relative;
  display: inline-block;
  color: #fff;
  /* text-transform: uppercase; */
  animation: waviy 1s infinite;
  animation-delay: calc(0.1s * var(--i));
}

@keyframes waviy {
  0%,
  40%,
  100% {
    transform: translateY(0);
  }

  20% {
    transform: translateY(-20px);
  }
}
.rainbow-text {
  background: linear-gradient(
    90deg,
    red,
    orange,
    yellow,
    green,
    blue,
    indigo,
    violet,
    red
  );
  background-size: 400% 400%;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: rainbow-move 8s linear infinite;
}

@keyframes rainbow-move {
  0% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0% 50%;
  }
}
/* end a1 */
.process-circle-wrap {
  position: relative;
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.process-circle {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  border: 3px solid #e29803;
  /* Vuetify primary color */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}

.process-circle-icon {
  font-size: 30px;
  margin-bottom: 10px;
}

.process-circle-num {
  position: absolute;
  bottom: -15px;
  background: #e29803;
  color: #fff;
  border-radius: 50%;
  padding: 5px 12px;
  font-weight: bold;
}
/* Shared hidden state */
.anim-item {
  opacity: 0;
  transition-property: opacity, transform;
  transition-duration: 800ms;
  transition-timing-function: cubic-bezier(0.2, 0.8, 0.2, 1);
}

/* When in-view */
.anim-item.in-view {
  opacity: 1;
  transform: translate(0, 0) scale(1);
}

/* Types */
.fade-up {
  transform: translateY(40px);
}
.fade-up.in-view {
  transform: translateY(0);
}

.fade-left {
  transform: translateX(40px);
}
.fade-left.in-view {
  transform: translateX(0);
}

.zoom-in {
  transform: scale(0.9);
}
.zoom-in.in-view {
  transform: scale(1);
}

/* Optional delay helpers */
.delay-100 {
  transition-delay: 0.1s;
}
.delay-150 {
  transition-delay: 0.15s;
}
.delay-200 {
  transition-delay: 0.2s;
}
.delay-300 {
  transition-delay: 0.3s;
}
@keyframes zoomInOut {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1); /* zoom in */
  }
  100% {
    transform: scale(1); /* back to normal */
  }
}

.zoom-effect {
  animation: zoomInOut 6s ease-in-out infinite; /* continuous zoom */
  transition: transform 0.3s ease-in-out;
}

.process-circle {
  position: relative;
  background: white;
  border-radius: 50%;
  padding: 30px;
  text-align: center;
  transition: all 0.4s ease; /* smooth animation */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  cursor: pointer;
}

.process-circle:hover {
  transform: scale(1.1) rotate(5deg); /* zoom + tilt */
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3); /* stronger glow */
}

.process-circle-icon {
  font-size: 32px;
  margin-bottom: 10px;
  transition: transform 0.4s ease;
}

.process-circle:hover .process-circle-icon {
  transform: rotate(360deg); /* spin icon */
}

.process-circle-text h3 {
  margin: 0;
  font-size: 18px;
  transition: color 0.3s ease;
}

.process-circle:hover .process-circle-text h3 {
  color: #e29803; /* change text color on hover */
}
.process-circle {
  opacity: 0;
  transform: translateY(50px);
  transition: all 0.8s ease;
}

.process-circle.visible {
  opacity: 1;
  transform: translateY(0);
}

.process-circle:nth-child(1) {
  transition-delay: 0.2s;
}
.process-circle:nth-child(2) {
  transition-delay: 0.4s;
}
.process-circle:nth-child(3) {
  transition-delay: 0.6s;
}
.process-circle:nth-child(4) {
  transition-delay: 0.8s;
}
.process-circle {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin: 0 auto;
  position: relative;
  cursor: pointer;

  /* 👇 add looping animation */
  animation: pulseLoop 3s ease-in-out infinite;
}

.process-circle-icon {
  font-size: 7px;
  margin-bottom: 8px;
  transition: transform 0.4s ease;
}

.process-circle-num {
  position: absolute;
  bottom: -20px;
  font-weight: bold;
  font-size: 18px;
  color: white;
}
.fontfamMon {
  font-family: Montserrat !important;
}
/* start */
.bg-section {
  background: url("@/assets/about-parrallax1.jpg") center center / cover no-repeat;
  width: 100%;
  /* Height grows automatically based on content */
}
.shine-text {
  background: linear-gradient(90deg, #0e0255 0%, black 50%, #0e0255 100%);
  background-size: 200% auto;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: shine 4s linear infinite;
}

@keyframes shine {
  to {
    background-position: 200% center;
  }
}
/* stop */
.shine-text2 {
  background: linear-gradient(90deg, #ffffff 0%, #ffdd00 50%, #ffffff 100%);
  background-size: 200% auto;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: shine 4s linear infinite;
}

@keyframes shine {
  to {
    background-position: 200% center;
  }
}

.timeline-circle {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background: radial-gradient(
    circle farthest-corner at 10% 20%,
    rgba(214, 40, 40, 1) 0%,
    rgba(255, 195, 0, 1) 90%
  );
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.2);
  position: relative;
  z-index: 1;
}

.timeline-num {
  margin-top: 10px;
  font-size: 18px;
  font-weight: bold;
  color: #1e88e5;
}
</style>
